<template>
    <div class="columns is-multiline">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="column is-full">
            <b-field label="Activar recoleccion de datos personalizada" message="Los campos personalizados te permiten ajustar la info que coleccionas del usuario durante el checkout a las necesidades de tu empresa.">
                <b-switch v-model="company.customOrderFields" @input="emitDetailsUpdate">
                </b-switch>
            </b-field>
            <b-field label="Titulo de seccion" message="Este nombre se muestra como titulo del formulario">
                <b-input
                @input="emitDetailsUpdate"
                v-model="company.customOrderSectionName">
                </b-input>
            </b-field>    
        </div>
        <div v-if="company.customOrderFields" class="column is-full">
            <hr>
            <div v-if="!fields.length" class="columns is-multiline ">
                <div class="column is-full has-text-centered">
                    <h2 class="title is-size-4 has-text-centered">Todavia no creaste ningun campo personalizado.</h2>
                </div>
            </div>
            <div v-else class="columns is-multiline">
                <div v-for="field in fields" :key="field.id" class="column is-half">
                    <div class="card">
                        <div class="card-content">
                            <a @click="deleteField(field.id)" class="has-text-danger m-b-5">
                                <b-icon icon="trash" size="is-small" class="m-r-5"></b-icon>
                                Delete
                            </a>
                            <b-field label="Nombre" label-position="on-border">
                                <b-input @input="updateField(field)" v-model="field.title"></b-input>
                            </b-field>
                            <b-field label="Tipo de campo" label-position="on-border">
                                <b-select @input="updateField(field)" v-model="field.fieldType">
                                    <option value="input">Texto</option>
                                    <option value="checkbox">Checkbox</option>
                                    <option value="select">Select</option>
                                </b-select>
                            </b-field>
                            <div v-if="field.fieldType == 'select'">
                                <p class="heading has-text-centered">Opciones</p>
                                <b-field v-for="option in field.optionsList" :key="option.id">
                                    <b-input 
                                    icon-right="trash"
                                    icon-right-clickable
                                    @icon-right-click="deleteOption(option.id)"
                                    @input="updateOption(option)"
                                    v-model="option.title"></b-input>
                                </b-field>
                                <div class="has-text-centered">
                                    <b-button
                                    @click="openNewOptionModal(field)"
                                    type="is-text"
                                    size="is-small">
                                        <b-icon icon="plus" size="is-small" class="m-r-5"></b-icon>
                                        Agregar opcion
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="has-text-centered">
                <b-button
                @click="addModalActive=true"
                type="is-primary"
                rounded>
                    <b-icon icon="plus" size="is-small" class="m-r-5"></b-icon>
                    Crear un campo
                </b-button>
            </div>
        </div>
        
        <b-modal :active.sync="addModalActive" scroll="keep" :can-cancel="false">
            <div class="modal-card" style="width:auto;">
                <div class="modal-card-body">
                    <div class="has-text-centered">
                        <h1 class="title is-size-4 m-b-10">Agrega un nuevo campo</h1>
                    </div>
                    <b-field label="Nombre" label-position="on-border">
                        <b-input v-model="newField.title"></b-input>
                    </b-field>
                    <b-field label="Tipo de campo" label-position="on-border">
                        <b-select v-model="newField.fieldType">
                            <option value="input">Texto</option>
                            <option value="checkbox">Checkbox</option>
                            <option value="select">Select</option>
                        </b-select>
                    </b-field>
                    
                    <div v-if="newField.fieldType == 'select'">
                        <p  class="heading has-text-centered">Opciones</p>
                        <b-field v-for="(x, index) in newField.options" :key="index">
                            <b-input v-model="x.title"
                            icon-right="trash"
                            icon-right-clickable
                            @icon-right-click="removeOptionNewField(index)"
                            ></b-input>
                        </b-field>
                        <b-button
                        type="is-text"
                        @click="addOptionNewField">
                            <b-icon icon="plus" size="is-small" class="m-r-5"></b-icon>
                            Agregar linea
                        </b-button>
                    </div>

                    <div class="has-text-centered m-t-10">
                        <b-button
                        type="is-light"
                        rounded
                        @click="addModalActive=false">
                            Cerrar
                        </b-button>
                        <b-button
                        rounded
                        type="is-primary"
                        :loading="createFieldLoading"
                        @click="createField">
                            <b-icon icon="save" size="is-small" class="m-r-5"></b-icon>
                            Guardar campo
                        </b-button>
                    </div>
            </div>
        </b-modal>

        <b-modal :active.sync="addOptionActive" scroll="keep" :can-cancel="false">
            <div class="modal-card" style="width:auto;">
                <div class="modal-card-body">
                    <div class="has-text-centered">
                        <h1 class="title is-size-4 m-b-10">Agrega opciones a {{fieldToAddOptions.title}}</h1>
                    </div>

                    <b-field v-for="(option, index) in newOptions" :key="index">
                        <b-input 
                        icon-right="trash"
                        icon-right-clickable
                        @icon-right-click="removeNewOption(index)"
                        v-model="option.title"></b-input>
                    </b-field>

                    <b-button
                    type="is-text"
                    @click="addNewOption"
                    >
                        <b-icon icon="plus" size="is-small" class="m-r-5"></b-icon>
                        Agregar linea
                    </b-button>

                    <div class="has-text-centered">
                        <b-button
                        class="m-r-5"
                        @click="closeNewOptionModal"
                        type="is-light"
                        rounded>
                            Cerrar
                        </b-button>
                        <b-button
                        type="is-primary"
                        rounded
                        @click="createNewOptions"
                        :loading="createFieldLoading">
                            Guardar
                        </b-button>
                    </div>

                </div>
            </div>
        </b-modal>


    </div>
</template>

<script>
import { getHandler, postHandler, debounce, patchHandler, deleteHandler } from '../../../../services/http'
export default {
    props:{
        company:{
            type:Object,
            default:new Object({})
        },
        customOrderFieldsUrl:{
            type:String,
            default:""
        },
        customOrderFieldsDetailUrl:{
            type:String,
            default:""
        },
        customOrderFieldsOptionsUrl:{
            type:String,
            default:""
        },
        customOrderFieldsOptionsDetailUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            fields:[],
            addModalActive:false,
            newField:{options:[{}]},
            fieldToAddOptions:{},
            addOptionActive:false,
            newOptions:[{title:""}],
            createFieldLoading:false
        }
    },
    methods:{
        emitDetailsUpdate: debounce(
            function(){
                this.$emit("updateDetails", this.company)
            },
            500
        ),
        async fetchFields(){
            this.loading = true
            var response = await getHandler(this.customOrderFieldsUrl, {error:false, success:false})
            this.fields = response
            this.loading = false
            this.fields = response
        },

        async createField(){
            this.createFieldLoading = true
            this.newField.company = this.company.id
            if(this.newField.fieldType != 'select'){
                delete this.newField.options
            }
            var response = await postHandler(this.customOrderFieldsUrl, this.newField, {error:false, success:false})
            this.createFieldLoading = false
            this.addModalActive=false
            this.newField = {options:[{}]}
            this.fetchFields()
        },

        updateField: debounce(
            async function(field){
                var success = {
                    resource:'notify',
                    text:'Campo de orden actualizado'
                }
                var error = {
                    resource:'notify',
                    text:'Algo salio mal'
                }
                var url = this.customOrderFieldsDetailUrl.replace('0000', field.id)
                var response = await patchHandler(url, field, {error, success})
                this.fetchFields()
            },
            700
        ),

        async deleteField(id){
            var url = this.customOrderFieldsDetailUrl.replace('0000', id)
            var success = {
                    resource:'notify',
                    text:'Opcion eliminada con exito'
                }
                var error = {
                    resource:'notify',
                    text:'No se elimino la opcion, algo salio mal.'
                }
            var response = await deleteHandler(url, {error, success})
            this.fetchFields()
        },

        async deleteOption(id){
            var url = this.customOrderFieldsOptionsDetailUrl.replace('0000', id)
            var success = {
                    resource:'notify',
                    text:'Opcion eliminada con exito'
                }
                var error = {
                    resource:'notify',
                    text:'No se elimino la opcion, algo salio mal.'
                }
            var response = await deleteHandler(url, {error, success})
            this.fetchFields()
        },

        updateOption: debounce(
            async function(option){
                var url = this.customOrderFieldsOptionsDetailUrl.replace('0000', option.id)
                var success = {
                    resource:'notify',
                    text:'Opcion cambiada con exito'
                }
                var error = {
                    resource:'notify',
                    text:'No se actualizo la opcion, algo salio mal.'
                }
                var response = await patchHandler(url, option, {error, success})
                this.fetchFields() 
            },
            700
        ),

        openNewOptionModal(field){
            this.fieldToAddOptions = field
            this.addOptionActive = true
        },

        closeNewOptionModal(){
            this.fieldToAddOptions = {}
            this.addOptionActive = false
            this.newOptions = [{title:""}]
        },

        addNewOption(){
            this.newOptions.push({title:''})
        },

        removeNewOption(index){
            this.newOptions.splice(index,1)
        },

        async createNewOptions(){
            this.createFieldLoading = true
            var success = {
                resource:'notify',
                text:'Opciones creadas con exito'
            }
            var error = {
                resource:'notify',
                text:'No se crearon las opciones, algo salio mal.'
            }
            this.newOptions.forEach(
                element=>{
                    element.customField = this.fieldToAddOptions.id
                }
            )
            console.log(this.newOptions)
            var response = await postHandler(this.customOrderFieldsOptionsUrl, this.newOptions, {error, success})
            this.createFieldLoading = false
            this.fieldToAddOptions = {}
            this.newOptions=[{title:''}]
            this.addOptionActive = false
            this.fetchFields()
        },

        addOptionNewField(){
            this.newField.options.push({title:''})
        },

        removeOptionNewField(index){
            this.newField.options.splice(index,1)
        }
    },
    mounted(){
        this.fetchFields()
    }
}
</script>